import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import VoucherGroupInfo from './VoucherGroupInfo';
import VoucherList from './VoucherList';

import { TEST_VOUCHER_GROUP, TEST_VOUCHERS } from './VoucherGroupTestData';
import { getVoucherGroup, getVouchersForGroup } from './api/VoucherGroupApi';

// Set this to true to use test data, false to use real API
const USE_TEST_DATA = false;

const VoucherGroupDetails = () => {
  const { voucherGroupId } = useParams();
  const [voucherGroup, setVoucherGroup] = useState(null);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (USE_TEST_DATA) {
          setVoucherGroup(TEST_VOUCHER_GROUP);
          setVouchers(TEST_VOUCHERS);
          setLoading(false);
        } else {
          const groupData = await getVoucherGroup(voucherGroupId);
          setVoucherGroup(groupData);
          const voucherData = await getVouchersForGroup(voucherGroupId);
          setVouchers(voucherData);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [voucherGroupId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data: {error.message}</div>;
  }

  return (
    <div className="p-4">
      <VoucherGroupInfo voucherGroup={voucherGroup} />
      <VoucherList voucherList={vouchers} voucherGroupId={voucherGroupId} />
    </div>
  );
};

export default VoucherGroupDetails;
